import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ChecklistPlacemarkBalloonService {
  public checklistPlacemarkChange: Subject<any> = new Subject<any>();

  constructor() { }

  public showChecklistPlacemarkBolloon(placemark, layer, position, isFromMultipleMenu) {
    this.checklistPlacemarkChange.next({placemark, layer, position, isFromMultipleMenu});
  }

  public hideChecklistPlacemarkBolloon(event: Event) {
    this.checklistPlacemarkChange.next({placemark: null, layer: null, position: null, mouseEvent: event});
  }
}
